/**
 * Map app mode to program types, then call {@link getPrograms}.
 */

import {
  PROGRAM_CASCADE_IN_PERSON_TYPES,
  PROGRAM_CASCADE_PAGE_SIZE,
  PROGRAM_CASCADE_REMOTE_TYPES,
} from '@/constants/shared-catalog';
import type { AppMode } from '@/contexts/ModeContext';
import { getPrograms } from '@/services/programs.service';

/** Query params accepted by {@link getPrograms}, excluding a forced `types` override. */
type ProgramListParams = NonNullable<Parameters<typeof getPrograms>[0]>;
/** Program type values used when filtering the programs list by app mode. */
type ProgramListType = 'in_person' | 'remote' | 'hybrid';

/** remote → remote+hybrid; anything else → in_person+hybrid. */
export function getProgramTypesForMode(mode: AppMode): ProgramListType[] {
  return mode === 'remote'
    ? [...PROGRAM_CASCADE_REMOTE_TYPES]
    : [...PROGRAM_CASCADE_IN_PERSON_TYPES];
}

/** `GET /academic/programs` — `types` always come from mode (params cannot override). */
export function getProgramsForMode(mode: AppMode, params?: Omit<ProgramListParams, 'types'>) {
  return getPrograms({
    pageSize: PROGRAM_CASCADE_PAGE_SIZE,
    ...params,
    types: getProgramTypesForMode(mode),
  });
}
